import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon, _Text, _hr, _span, _InfoIcon, _Glyphicon2, _hr2;
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import clsx from 'clsx';
import _get from 'lodash/get';
import { Button, Glyphicon, InfoIcon, List, LinkTile, OverlayTrigger, Popover, Text } from 'reaxl';
import { OwnerAddress, OwnerDistance, OwnerPhoneNumber, OwnerWebsiteCTA } from 'reaxl-molecules';
import { homeServicesConfig as homeServices } from 'reaxl-home-services';
import { EmailCTA, OneClickButton } from 'reaxl-email';
import { useFeatures } from '@atc/features';
import { sendClick } from 'reaxl-analytics';
import { inventoryListingViewEllipsesClick } from 'reaxl-analytics-handlers';
import { useBrand } from '@atc/brand';
import DealerDiffCTA from '../DealerDiffCTA/index.js';
const renderSellerPhone = _ref => {
  let {
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "display-flex"
  }, void 0, /*#__PURE__*/React.createElement(OwnerPhoneNumber, Object.assign({
    className: "display-block",
    key: "listingFooterOwnerPhone"
  }, props)));
};
const renderDealerDiffCTA = _ref2 => {
  let {
    dealerDiffCTA,
    onDealerDiffCTAClick
  } = _ref2;
  const showDealerDiffCTA = dealerDiffCTA && dealerDiffCTA.label && onDealerDiffCTAClick;
  return showDealerDiffCTA && /*#__PURE__*/React.createElement(DealerDiffCTA, Object.assign({
    key: "dealerDiffCTA",
    onDealerDiffCTAClick: onDealerDiffCTAClick
  }, dealerDiffCTA));
};
const renderTiles = _ref3 => {
  let {
    listing,
    onCertifiedTileClick,
    onCertifiedTileLinkClick,
    onProductTileClick,
    onProductTileLinkClick,
    enableCpoVhrBadges,
    isFord
  } = _ref3;
  const productTiles = listing.productTiles && listing.productTiles.map((tile, i) => /*#__PURE__*/React.createElement(LinkTile, Object.assign({}, tile, {
    imageHeight: isFord ? '30' : '20',
    imageWidth: isFord ? '90' : '65',
    isProductTile: true,
    onTileClick: event => onProductTileClick(event, listing),
    onLinkClick: event => onProductTileLinkClick(event, listing),
    className: "margin-right-2",
    key: `product-tile-${i}`
  })));
  const certifiedTiles = listing.certifiedTiles && listing.certifiedTiles.map((tile, i) => /*#__PURE__*/React.createElement(LinkTile, Object.assign({}, tile, {
    imageHeight: isFord ? '30' : '20',
    imageWidth: isFord ? '103' : '73',
    onTileClick: event => onCertifiedTileClick(event, listing),
    onLinkClick: event => onCertifiedTileLinkClick(event, listing),
    linkVisible: false,
    className: "margin-right-2",
    key: `certified-tile-${i}`
  })));
  return /*#__PURE__*/_jsx("div", {
    className: "display-flex"
  }, void 0, !enableCpoVhrBadges && productTiles, ' ', isFord && certifiedTiles);
};

/* render home services in same order they appear in axl-config
 * 1) virtual tour 2) test drive 3) home delivery
 */
const renderHomeServices = _ref4 => {
  let {
    className,
    owner,
    shippingLabel
  } = _ref4;
  const {
    testDrive,
    vehicleDelivery,
    virtualTour
  } = homeServices;
  const hasHomeDelivery = _get(owner, 'homeServices.vehicleDelivery', false) && !shippingLabel;
  const hasTestDrive = _get(owner, 'homeServices.testDrive', false);
  const hasVirtualTour = _get(owner, 'homeServices.virtualTour', false);
  const servicesList = [];
  const getAtHomeServicesDealerProducts = () => {
    if (hasVirtualTour) {
      servicesList.push(virtualTour.title);
    }
    if (hasTestDrive) {
      servicesList.push(testDrive.title);
    }
    if (hasHomeDelivery) {
      servicesList.push(vehicleDelivery.title);
    }
    return servicesList;
  };
  const atHomeServices = getAtHomeServicesDealerProducts();
  return servicesList.length > 0 && /*#__PURE__*/_jsx("div", {
    className: className,
    "data-cmp": "dealerProducts"
  }, "listingFooterDealerProducts", /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(List, {
    inline: true,
    items: atHomeServices
  })));
};
const renderOnlineServices = _ref5 => {
  let {
    className,
    listing,
    owner,
    shippingLabel
  } = _ref5;
  const {
    accelerate: onlinePaperwork,
    buyOnline
  } = homeServices;
  const hasOnlinePaperwork = _get(listing, 'accelerate', false);
  const hasBuyOnline = _get(owner, 'homeServices.buyOnline', false);
  const isPrivateSeller = _get(listing, 'owner.privateSeller', false);
  const isIMEListing = _get(listing, 'marketExtension.imeDmaMatch', false);
  const servicesList = [];
  const getOnlineDealerProducts = () => {
    if (hasOnlinePaperwork) {
      servicesList.push(onlinePaperwork.title);
    }
    if (hasBuyOnline || isPrivateSeller) {
      servicesList.push(isPrivateSeller ? /*#__PURE__*/_jsx("span", {
        className: "display-inline-flex flex-nowrap"
      }, void 0, buyOnline.inventoryListingFooterTitle) : buyOnline.title);
    }
    if (shippingLabel || isIMEListing) {
      servicesList.push(/*#__PURE__*/React.createElement(React.Fragment, null, isIMEListing ? 'Delivery' : shippingLabel, _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "delivery-truck",
        className: "text-size-400 margin-bottom-1 margin-horizontal-1 glyphicon-stack"
      }))));
    }
    return servicesList;
  };
  const onlineServices = getOnlineDealerProducts();
  return onlineServices.length > 0 && /*#__PURE__*/_jsx("div", {
    className: className,
    "data-cmp": "dealerProducts"
  }, "listingFooterDealerProducts", /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(List, {
    inline: true,
    items: onlineServices,
    className: "text-bold"
  })));
};
const renderRequestAQuote = _ref6 => {
  let {
    listing,
    emailOwnerProps,
    isPreorder,
    orientation,
    owner
  } = _ref6;
  const showRequestAQuote = isPreorder && emailOwnerProps;
  const isPortrait = orientation === 'portrait';
  const classNames = clsx({
    'align-items-center': true,
    'text-center': true,
    'padding-bottom-3': !isPortrait,
    'padding-bottom-4': isPortrait,
    'margin-top-3': isPortrait,
    'w-100': isPortrait
  });
  return showRequestAQuote && /*#__PURE__*/_jsx("div", {
    className: classNames
  }, void 0, /*#__PURE__*/_jsx(EmailCTA, {
    buttonStyle: "primary",
    className: "margin-bottom-3",
    labelKey: "quote",
    onClick: emailOwnerProps.onCTAClick,
    onBuildClick: emailOwnerProps.onBuildClick,
    type: "block",
    listingId: listing.id,
    ownerId: owner.id
  }, "quote"), _Text || (_Text = /*#__PURE__*/_jsx(Text, {}, void 0, "For illustration purposes only. May not match exact trim or color of the vehicle shown. No obligation to purchase.")));
};
function RenderInventoryListingFooter(_ref7) {
  let {
    clickType,
    owner = {},
    listing,
    listingQuickActions,
    emailOwnerProps,
    handleEditEmail,
    isActiveDeal,
    isPhoneNumberCallable,
    isKbbBranded,
    phoneClickHandler,
    onCertifiedTileClick,
    onCertifiedTileLinkClick,
    onDealerDiffCTAClick,
    onProductTileClick,
    onProductTileLinkClick,
    oneClickEmailSent,
    orientation,
    parentId,
    secondaryContent,
    showDistance,
    showEditEmail,
    showEllipses,
    showSections,
    uiContext,
    paginatedListingIndex,
    onOnlinePaperworkClick,
    onSelectPsxListing,
    ...rest
  } = _ref7;
  const {
    enable_cpo_vhr_badges: [, {
      show_cpo_vhr_badges: enableCpoVhrBadges
    }],
    email: [isEmailEnable, {
      override_hide_email: enableConfirmAvailabilityCta
    }],
    direct_to_vdp_cta: [isDirectToVdpCtaEnabled, {
      label: directToVdpCtaLabel
    }]
  } = useFeatures(['enable_cpo_vhr_badges', 'email', 'direct_to_vdp_cta']);
  const {
    isBrand
  } = useBrand();
  const isFord = isBrand('ford');
  const isIMEListing = _get(listing, 'marketExtension.imeDmaMatch', false);
  const {
    dealerDiff,
    hideEmailForm,
    location,
    name,
    phone,
    privateSeller,
    shipToStore,
    shippingLabel,
    website
  } = owner;
  const displayOwnerName = listing.ownerName || name;
  const isAlpha = uiContext === 'alpha';
  const isPreorder = uiContext === 'preorder';
  const isPortrait = orientation === 'portrait';
  const isSimplifiedListing = uiContext === 'simplified';
  const isSponsoredListing = uiContext === 'sponsored';
  const city = location?.address?.city;
  const isBuyOnline = owner.homeServices?.buyOnline;
  const hasOwnerWebsite = !!website?.href;

  // show email CTA only when dealer has a phone number
  // remove isVisible below once monolith is retired
  const phoneVisible = phone && (phone.visible || phone.isVisible);
  const isEmailCtaEnabled = isEmailEnable && enableConfirmAvailabilityCta;
  const isEmailEligible = !isPreorder && !privateSeller && emailOwnerProps && phoneVisible && !hideEmailForm;
  const showEmailOwnerCTA = isEmailCtaEnabled || isEmailEligible;
  const showEditEmailCTA = showEmailOwnerCTA && showEditEmail;
  const showContactInfo = uiContext !== 'snapshot' && (phone || showEmailOwnerCTA);
  const classNames = clsx('static-height-footer', {
    'display-flex flex-column': isPortrait
  });
  const analyticsData = {
    par: parentId,
    inventoryId: listing.id,
    ownerId: owner.id,
    clickType,
    paginatedListingIndex
  };
  const ownerAddress = city && /*#__PURE__*/_jsx(OwnerAddress, {
    location: location,
    analyticsData: analyticsData
  });
  const atHomeServices = renderHomeServices({
    className: 'text-subdued margin-top-2',
    owner,
    shippingLabel
  });
  const popoverDealerDiffCTA = uiContext !== 'snapshot' && !isPreorder && renderDealerDiffCTA({
    dealerDiffCTA: dealerDiff,
    onDealerDiffCTAClick
  });
  const handleClick = event => {
    event.stopPropagation(); // Prevent ancestor React elements from receiving click
    event.preventDefault(); // Prevent ancestor <a> from navigating to VDP
    event.nativeEvent.stopImmediatePropagation(); // Prevent BIRF from navigating after click delay
  };
  const handleEllipsisClick = (event, data) => {
    sendClick(inventoryListingViewEllipsesClick, event, {
      ...data,
      inventoryId: listing?.id,
      par: parentId
    });
  };
  const handleSelectPsxListing = event => {
    event.stopPropagation();
    event.preventDefault();
    onSelectPsxListing(event, listing);
  };
  const ownerInfoList = [];
  if (displayOwnerName && !isIMEListing && !isAlpha && (!isBuyOnline || privateSeller)) {
    ownerInfoList.push(/*#__PURE__*/_jsx("div", {
      className: "display-flex align-items-center"
    }, "ownerDistance", /*#__PURE__*/_jsx(OwnerDistance, {
      className: "text-subdued",
      displayOwnerName: displayOwnerName,
      owner: owner,
      uiContext: "owner",
      showIcon: false,
      showOwnerDistance: showDistance,
      analyticsData: analyticsData
    })));
  }
  if (showContactInfo && !isPhoneNumberCallable && phone && !privateSeller) {
    ownerInfoList.push(/*#__PURE__*/_jsx("div", {
      className: "text-subdued display-flex",
      "data-cmp": "contactInfo"
    }, "listingFooterContactInfo", renderSellerPhone({
      phone,
      isCallable: isPhoneNumberCallable,
      analyticsData,
      phoneClickHandler
    })));
  }
  const renderOffsiteOwnerTitle = /*#__PURE__*/_jsx(OwnerWebsiteCTA, {
    analyticsData: analyticsData,
    className: "text-gray-base",
    href: website?.href,
    label: displayOwnerName,
    uiContext: "link"
  }, "offsiteOwnerTitle");
  const renderOwnerTitle = /*#__PURE__*/_jsx("span", {
    className: "text-gray-base"
  }, "ownerTitle", displayOwnerName);
  const renderEllipsesOwnerTitle = /*#__PURE__*/_jsx(Fragment, {}, "ownerTitle", /*#__PURE__*/_jsx("span", {
    className: "text-subdued text-bold"
  }, void 0, displayOwnerName));
  const renderTitle = /*#__PURE__*/_jsx("div", {
    className: "margin-top-3 margin-bottom-4"
  }, void 0, hasOwnerWebsite ? renderOffsiteOwnerTitle : renderOwnerTitle);
  const renderOwnerName = () => {
    if (!displayOwnerName || isAlpha) return null;
    if (isSponsoredListing) return `Sponsored by ${displayOwnerName}`;
    return isFord ? displayOwnerName : null;
  };
  const customPopover = showEllipses && /*#__PURE__*/_jsx(Popover, {
    id: "inventoryFooterPopover",
    className: "quick-actions-popover",
    onClick: e => e.stopPropagation(),
    onCloseClick: () => {}
  }, 'customPopover' + listing.id, /*#__PURE__*/_jsx("div", {
    className: "text-subdued-lightest text-size-200"
  }, void 0, !isFord && renderEllipsesOwnerTitle, /*#__PURE__*/_jsx(List, {
    items: ownerInfoList,
    inline: true,
    className: clsx('margin-bottom-1 display-block text-size-200')
  }), ownerAddress, atHomeServices, popoverDealerDiffCTA), /*#__PURE__*/_jsx("div", {
    className: "text-size-200"
  }, void 0, ownerAddress || popoverDealerDiffCTA || atHomeServices?.length > 0 ? _hr || (_hr = /*#__PURE__*/_jsx("hr", {
    className: "margin-bottom-4"
  })) : null, listingQuickActions));
  const isLandscapeAlpha = isAlpha && !isSimplifiedListing && !isPortrait;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isLandscapeAlpha && !isSimplifiedListing && /*#__PURE__*/_jsx("div", {
    className: classNames
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: "text-left margin-bottom-2"
  }, void 0, shipToStore && (_span || (_span = /*#__PURE__*/_jsx("span", {
    className: "margin-right-1"
  }, void 0, "Can be shipped to"))), /*#__PURE__*/_jsx("div", {
    className: "text-subdued"
  }, void 0, isAlpha && renderTitle, isAlpha && phone && isPhoneNumberCallable && !privateSeller && renderSellerPhone({
    phone,
    isCallable: isPhoneNumberCallable,
    analyticsData,
    phoneClickHandler
  }), renderOwnerName(), shipToStore && (_InfoIcon || (_InfoIcon = /*#__PURE__*/_jsx(InfoIcon, {
    placement: "top",
    infoText: "This dealership might not have this vehicle on their lot right now, but they can have it shipped to them. Talk to the dealer to arrange it.",
    className: "margin-left-1"
  })))), /*#__PURE__*/_jsx("div", {
    className: "display-flex"
  }, void 0, /*#__PURE__*/_jsx(List, {
    items: ownerInfoList,
    inline: true
  })), uiContext !== 'alpha' && renderOnlineServices({
    className: 'text-subdued',
    listing,
    owner,
    shippingLabel
  })), uiContext !== 'snapshot' && uiContext !== 'alpha' && showSections.tiles && renderTiles({
    listing,
    onCertifiedTileClick,
    onCertifiedTileLinkClick,
    onProductTileClick,
    onProductTileLinkClick,
    enableCpoVhrBadges,
    isFord,
    ...rest
  }), renderRequestAQuote({
    listing,
    emailOwnerProps,
    isPreorder,
    orientation,
    owner
  })), !isLandscapeAlpha && /*#__PURE__*/_jsx("div", {
    className: "display-flex gap-2 margin-top-2"
  }, void 0, !isDirectToVdpCtaEnabled && showEmailOwnerCTA && !showEditEmail && /*#__PURE__*/_jsx(Fragment, {}, "emailOwnerCTA", /*#__PURE__*/_jsx(EmailCTA, {
    clickType: clickType,
    parentId: parentId,
    listingId: listing.id,
    context: emailOwnerProps.context,
    onClick: emailOwnerProps.onCTAClick,
    buttonStyle: "default",
    buttonSize: "small",
    className: "flex-1 display-flex",
    showIcon: false,
    type: "block",
    labelKey: emailOwnerProps.labelKey
  }, "email-cta")), showEditEmailCTA && /*#__PURE__*/_jsx(OneClickButton, {
    listingId: listing.id,
    oneClickEmailSent: oneClickEmailSent,
    handleEmailSendClick: emailOwnerProps.onCTAClick,
    handleEditSettingsClick: handleEditEmail,
    wrapperClassNames: "w-100 display-flex"
  }), phone && isPhoneNumberCallable && !privateSeller && renderSellerPhone({
    phone,
    isCallable: isPhoneNumberCallable,
    analyticsData,
    phoneClickHandler,
    uiContext: 'button',
    buttonStyle: 'default',
    buttonSize: 'small',
    buttonLabel: 'Call'
  }), !isDirectToVdpCtaEnabled && privateSeller && onSelectPsxListing && /*#__PURE__*/_jsx(Button, {
    block: true,
    bsSize: "small",
    bsStyle: "default",
    "data-cmp": "btn-makeOffer",
    onClick: handleSelectPsxListing
  }, void 0, "Make Offer"), isDirectToVdpCtaEnabled && /*#__PURE__*/_jsx(Button, {
    block: true,
    bsSize: "small",
    bsStyle: "default",
    "data-cmp": "btn-shopNow"
  }, void 0, directToVdpCtaLabel), showEllipses && /*#__PURE__*/_jsx(OverlayTrigger, {
    onClick: handleClick,
    trigger: "click",
    rootClose: true,
    placement: "top",
    overlay: customPopover,
    className: "margin-left-auto"
  }, void 0, /*#__PURE__*/_jsx(Button, {
    "data-cmp": "footerEllipses",
    bsSize: "small",
    onClick: handleEllipsisClick,
    className: "padding-horizontal-1",
    "aria-label": "More actions"
  }, void 0, _Glyphicon2 || (_Glyphicon2 = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "ellipsis-horizontal",
    className: "text-size-500"
  }))))), secondaryContent);
}
/**
 *  Describe the component
 *
 */
function InventoryListingFooter(_ref8) {
  let {
    clickType,
    emailOwnerProps = {},
    handleEditEmail = () => {},
    isActiveDeal,
    isKbbBranded,
    isPhoneNumberCallable,
    listing,
    listingQuickActions,
    oneClickEmailSent = false,
    onCertifiedTileClick,
    onCertifiedTileLinkClick,
    onDealerDiffCTAClick,
    onOnlinePaperworkClick = () => {},
    onProductTileClick,
    onProductTileLinkClick,
    orientation,
    paginatedListingIndex,
    parentId,
    phoneClickHandler = () => {},
    secondaryContent,
    showDealerServices,
    showDistance = true,
    showEditEmail = false,
    showEllipses = false,
    showSections = {
      tiles: true
    },
    uiContext,
    onSelectPsxListing,
    ...rest
  } = _ref8;
  delete rest.secondaryContent;

  // Destructure listing data object
  const {
    owner = {}
  } = listing;
  const {
    phone
  } = owner;
  const ownerInfo = {
    owner,
    emailOwnerProps,
    parentId,
    phone,
    isPhoneNumberCallable,
    listing,
    orientation
  };
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "listing-footer text-subdued-lightest text-size-100 padding-horizontal-3"
  }, rest), uiContext !== 'simplified' && (_hr2 || (_hr2 = /*#__PURE__*/_jsx("hr", {}))), RenderInventoryListingFooter({
    ...ownerInfo,
    clickType,
    handleEditEmail,
    phoneClickHandler,
    isKbbBranded,
    listing,
    listingQuickActions,
    uiContext,
    oneClickEmailSent,
    onDealerDiffCTAClick,
    onCertifiedTileClick,
    onCertifiedTileLinkClick,
    onProductTileClick,
    onProductTileLinkClick,
    secondaryContent,
    showSections,
    showEditEmail,
    showEllipses,
    showDistance,
    paginatedListingIndex,
    onOnlinePaperworkClick,
    onSelectPsxListing,
    ...rest
  }));
}
export default InventoryListingFooter;